import {
  InputPart,
  InputTypes,
  TemplatePartTypes
} from "../../logic/templating/types";
import filterTemplateParts from "../../logic/templating/utils/filterTemplateParts";
import { SimpleCalculationState } from "../hooks/useSimpleCalculationActions";
import { Content } from "../types";

export function initialiseState({
  content,
  answers,
  workings = [""],
  markSchemeOpened = false
}: {
  content: Content;
  answers?: string[];
  workings?: string[];
  markSchemeOpened?: boolean;
}): SimpleCalculationState {
  return {
    answers:
      answers ||
      filterTemplateParts<InputPart>(
        content.answerParts,
        TemplatePartTypes.INPUT
      ).map(_ => ""),
    correctSteps: [],
    currentStepInd: 0,
    validations: [],
    isScaffolded: false,
    markSchemeOpened,
    stepInputValues: content.scaffoldedParts.map(parts =>
      filterTemplateParts<InputPart>(parts, TemplatePartTypes.INPUT).map(it =>
        it.inputType === InputTypes.PLACEHOLDER_LATEX
          ? it.valueWithPlaceholder
          : ""
      )
    ),
    submitted: false,
    workings
  };
}
